export default [
    // Sudeste
    // Sudeste
    // Sudeste
    {
        name: 'TECMAR Matriz',
        pos: [70.75, 68.35],
        main: true,
        phone: '(11) 3613-5922',
        cep: '06816-005',
        address: [
            'R. da Congregação, 206',
            'Bairro Gramado',
            'Embu das Artes - SP',
        ],
    },
    {
        name: 'TECMAR Sorocaba',
        pos: [70.25, 66.5],
        phone: '(15) 3225-2403 / (15) 3225-2679 / (15) 3225-2736 / (15) 3225-4299',
        cep: '18103-008',
        address: [
            'Av. Conde Zeppelin, 3356',
            'Bairro Eden',
            'Sorocaba - SP'
        ],
    },
    {
        name: 'TECMAR Campinas',
        pos: [68.5, 67],
        phone: '(19) 2660-2029',
        cep: '13069-123',
        address: [
            'Av. Maria Herminia Iamarino Ramos, 1411',
            'Bairro Nova Aparecida TIC',
            'Campinas - SP'
        ],
    },
    {
        name: 'TECMAR Extrema',
        pos: [68.75, 68.75],
        phone: '(35) 3100-3100',
        cep: '37640-000',
        address: [
            'Rua: Luiz Albino de Oliveira 36 Galpão',
            'Bairro do Pessegueiros Dist. Industrial ',
            'Extrema - MG'
        ],
    },
    {
        name: 'TECMAR Pouso Alegre',
        pos: [66.5, 70.25],
        phone: '(35) 3311-1000 (35) 3311-1006 / (35) 3311-10040',
        cep: '37561-110',
        address: [
            'Av. Prefeito Olavo Gomes de Oliveira, 7807/1',
            'Loteamento Parati',
            'Pouso Alegre - MG'
        ],
    },
    {
        name: 'TECMAR Serra',
        pos: [60, 84],
        phone: '(27) 2464-2958',
        cep: '29161-382',
        address: [
            'Rod.Gov.Mario Covas, BR 101, Av.Seiscentos S/N',
            'Dentro Emp.GHIOSOLFI Doca 4e5',
            'Serra - ES'
        ],
    },

    // Sul
    // Sul
    // Sul
    {
        name: 'TECMAR Curitiba',
        pos: [75.5, 61.5],
        phone: '(41) 3753-2100 / (41) 3753-2108',
        cep: '83085-120',
        address: [
            'Rua João Alves Figueiredo, nº 20',
            'Bairro Quissisana',
            'São Jose dos Pinhais - PR'
        ],
    },
    {
        name: 'TECMAR Blumenau',
        pos: [80.5, 61.5],
        phone: '(47) 3334-6565 / (47) 3334-0925',
        cep: '89065-130',
        address: [
            'Rua: Ari Barroso, 1166',
            'Bairro Itoupavazinha',
            'Blumenau - SC'
        ],
    },
    {
        name: 'TECMAR Joinville',
        pos: [78.5, 62.25],
        phone: '(47) 3436-5647 / (47)3463-4894 / (47) 3429-5812 ',
        cep: '89233-140',
        address: [
            'Rua Portugal 851 Galpão 2E',
            'Bairro Santa Catarina',
            'Joinville - SC'
        ],
    },
    {
        name: 'TECMAR Cachoeirinha',
        pos: [87.25, 56.75],
        phone: '(51) 3469-5600 / (51) 3469-5600 / (51) 3469-5632',
        cep: '94935-211',
        address: [
            'Av Frederico Augusto Ritter, 2001',
            'Distrito Industrial Ritter ',
            'Cachoeirinha - RS'
        ],
    },
    {
        name: 'TECMAR Caxias do Sul',
        pos: [85, 56.5],
        phone: '0',
        cep: '',
        address: [
            '',
            '',
            ''
        ],
    },
    
    // Nordeste
    // Nordeste
    // Nordeste
    {
        name: 'TECMAR Salvador',
        pos: [42.5, 88.5],
        phone: '(71) 3295-4900 / (71) 3295-4903',
        cep: '43700-000',
        address: [
            'Via Urbana, 3139',
            'Cia Sul',
            'Simões Filho - BA'
        ],
    },
    {
        name: 'TECMAR Feira de Santana',
        pos: [41, 87.25],
        phone: '(75) 3614-7100',
        cep: '44079-002',
        address: [
            'Av. Dep.Luis Eduardo Magalhães , S/N, km 103 bl B CIS',
            'Bairro Subae BR 324',
            'Feira de Santana - BA'
        ],
    },
    {
        name: 'TECMAR Aracajú',
        pos: [38.5, 92],
        phone: '(79) 3253-6000',
        cep: '49160-000',
        address: [
            'Av. Boa Viagem, S/N, loteamento Jardim Itacanema',
            'Povoado Sobrado',
            'Nossa Senhora do Socorro - SE'
        ],
    },
    {
        name: 'TECMAR Maceió',
        pos: [35.5, 95],
        phone: '(82) 3142-0538',
        cep: '57081-520',
        address: [
            'Rua Paulo Henrique Mendes nº 75',
            'Bairro Tabuleiro do Martins - Distrito Industrial',
            'Maceió - AL'
        ],
    },
    {
        name: 'TECMAR Recife',
        pos: [32.25, 97],
        phone: '(81) 3512-5500 / (81) 3512-5534 / (81) 3512-5520',
        cep: '54503-010',
        address: [
            'Rod. BR 101 Sul, 9200 Km 96',
            'Ponte dos Carvalhos',
            'Cabo de Santo Agostinho - PE'
        ],
    },
    {
        name: 'TECMAR João Pessoa',
        pos: [29, 97.25],
        phone: '(83) 3233-1366 / (83) 3233-1409 / (83) 3262-7838 / (83) 3262 7839',
        cep: '58084-000',
        address: [
            'Rua Martinho Lutero, 60',
            'Jardim Veneza',
            'João Pessoa - PB'
        ],
    },
    {
        name: 'TECMAR Natal',
        pos: [25.75, 96.25],
        phone: '(84) 3604-5900 / (84) 3604-5901/02/08',
        cep: '59146-480',
        address: [
            'Av. Piloto Pereira Tim, 314',
            'Galpão 2 - Parque de Exposição',
            'Parnamirim - RN'
        ],
    },
    {
        name: 'TECMAR Fortaleza',
        pos: [21.25, 87.75],
        phone: '(85) 3403-4400 / (85) 3403-4409 / (85) 3403-4401',
        cep: '60873-844',
        address: [
            'Av. 4º Anel Viário, nº 2700 H',
            'Bairro Pedras',
            'Fortaleza - CE'
        ],
    },

    // Centro-Oeste
    // Centro-Oeste
    // Centro-Oeste
    {
        name: 'TECMAR Goiânia',
        pos: [53, 61.5],
        phone: '(62) 3532-6200 / (62) 3532-6201',
        cep: '74445-190',
        address: [
            'Av. Avenida Perimetral Norte Nº 3472',
            'Vila João Vaz',
            'Goiania - GO'
        ],
    },

    // Norte
    // Norte
    // Norte
]